import { useParams } from 'react-router-dom'
import { DEFAULT_LANG, isLangCode } from './languages'
import type { LangCode } from './languages'

export function useLang(): LangCode {
  const { lang } = useParams<{ lang: string }>()
  return isLangCode(lang) ? lang : DEFAULT_LANG
}

/** Prefixes an app-internal path (e.g. "/kontakty") with the current language segment. */
export function withLang(lang: LangCode, path: string): string {
  const clean = path.startsWith('/') ? path : `/${path}`
  return `/${lang}${clean === '/' ? '' : clean}`
}
